import Filters from "../search-results/components/Filters";
import InfiniteHits from "../search-results/components/InfiniteHits";
import { InfinitePagination } from "../search-results/components/InfinitePagination";
import { cn } from "../utils/cn";
import QuickFilters from "../search-results/components/QuickFilters";
import { CurrentFilters } from "./CurrentFilters";
import ResultsTotal from "./ResultsTotal";
import { ScrollArea } from "./ui/ScrollArea";

export default function ProductList({ hitsPerPage, usePromo = false }: { hitsPerPage: number, usePromo?: boolean }) {
  // This is show nothing underneath can be seen while sticky (moves bg color all the way out)
  const stickyBarFullScreenWidth = `tw-px-10 -tw-mx-10`;

  return (
    <>
      {/* spacer/border in own div so when sticky below is 'active' the border doesn't get 'stuck' */}
      <div className="FilterSpacer tw-mt-10 tw-border-t tw-border-search-grey/25"></div>

      <div className="tw-flex tw-flex-col tw-w-full">
          <div className={cn(
              "tw-sticky tw-top-0 tw-z-10 tw-bg-white tw-py-5 tw-flex tw-justify-between tw-flex-wrap tw-gap-y-5",
              stickyBarFullScreenWidth
          )}>
            <ScrollArea orientation="horizontal" thumbBgColor="tw-bg-transparent" className="tw-max-w-full tw-pb-3 quick-filter-bar">
              <div className="tw-flex tw-space-x-8">
                  <Filters />
                  <QuickFilters />
              </div>
            </ScrollArea>

            <p><ResultsTotal className="tw-ml-auto" /></p>
          </div>

          <CurrentFilters />

          <div className="tw-mt-8">
              <InfiniteHits hitsPerPage={hitsPerPage} usePromo={usePromo} />
              <InfinitePagination />
          </div>
      </div>
    </>
  );
}